import React from 'react';
import './HomePage.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import HeroSection from '../../components/HeroSection/HeroSection';
import Solutions from '../../components/Solutions/Solutions'
import WorkSection from '../../components/WorkSection/WorkSection';
import HomeAbout from '../../components/HomeAbout/HomeAbout';
import DepartmentHead from '../../components/DepartmentHead/DepartmentHead';
import Testimonials from '../../components/Testimonials/Testimonials';
import Resources from '../../components/Resources/Resources';

const HomePage = () => {
    return (
        <div className="App">
            <HeroSection />
            <Solutions />
            <WorkSection />
            <HomeAbout />
            <DepartmentHead />
            <Testimonials />
            <Resources />
        </div>       
    );
}

export default HomePage;